import { DatePicker } from "@shared/antd/date-picker";
import { Form } from "@shared/antd/form";
import { Input } from "@shared/antd/input";
import { Card } from "@shared/antd/card";
import { Spin } from "@shared/antd/spin";
import { Select } from "@shared/antd/select";
import { Modal } from "@shared/antd/modal";
import * as React from "react";
import { ChangeEvent } from "react";
import { inject, observer } from "mobx-react";
import { FormattedMessage, injectIntl, WrappedComponentProps } from "react-intl";
import moment from "moment/moment";

import "./style.less";
import { action, observable } from "mobx";
import { collection } from "@cuba-platform/react";
import { withRouter } from "react-router";
import { RouteComponentProps } from "react-router-dom";
import { get } from "app/shared/lodash/lodash";
import { UcoSignSignature } from "../../../../cuba/entities/base/ucosign$Signature";
import { DicAssessmentStatus } from "../../../../cuba/entities/base/tsadv$DicAssessmentStatus";
import { LearningBudgetAttachment } from "../../../../cuba/entities/base/tsadv_LearningBudgetAttachment";
import { renderFileLink } from "../../LearningBudget/Approvment/AttachmentsComponent";
import { restServices } from "../../../../cuba/services";
import { RootStoreProp } from "../../../store";
import Button from "../../../components/Button/Button";
import CollapsibleCard from "../../../common/card-collapse";
import Section from "../../../hoc/Section";
import { TextArea } from "app/shared/antd/text-area";
import { DocumentSignatureComponentNew } from "../../../common/document-signature/document-signature";
import { ChangeDocumentInfo } from "../../BusinessTripRequest/BusinessTripRequestEdit";
import AttachmentsComponent from "../../LearningBudget/component/attachments-component";
import { IOrderRegisterSheet, OrderRegisterSheetTask } from "./order-register-sheet.type";
import { TableAdaptive } from "../../../common";
import { ColumnProps } from "antd/lib/table";

type Props = { entityId: string; orderId: string }

type State = {
  orderRegisterSheet: IOrderRegisterSheet | null;
  isLoading: boolean;
  isLoadingSheet: boolean;
  selectedStatuses: any;
  selectedComment: any;
  isModalVisible: boolean;
  selectedTask: string | null;
  orderRegisterSheetId: string;
  checkedBalance: boolean;
  isLoadingDocument: boolean;
  isSaving: boolean;
  isRevised: boolean;
  isNotAttach: boolean;
  documentInfo: {
    finalFile: boolean;
    isSignatureRequired: boolean;
    ucoSignRegistrationId: string[];
    signature: UcoSignSignature[] | null;
  };
}

const CODE = "Not_completed";

// <FormattedMessage id="annualSalaryRevisionRequest.table.position" />;
// {
//   item?.personGroupEndAssignment?.organizationGroup["_instanceName"];
// }
// <FormattedMessage id="bproc.startBproc.modal.user" />;
// {
//   item.personGroupEnd?._instanceName;
// }
// <FormattedMessage id="endDate" />;
// {
//   item.dateEnd;
// }
// <FormattedMessage id="cba.detail.comments" />;
// {
//   item.commentEnd;
// }

export const getTaskColumns = (intl: any, requestStatusColor: any, onExpandChild: any): ColumnProps<OrderRegisterSheetTask>[] => [
  {
    title: <FormattedMessage id="annualSalaryRevisionRequest.table.position" />,
    dataIndex: "organizationGroup",
    key: "organizationGroup",
    ellipsis: true,
    render: (_, record) => {
      return (record?.personGroupEndAssignment?.organizationGroup?.["_instanceName"]);
    },
  },
  {
    title: <FormattedMessage id="bproc.startBproc.modal.user" />,
    dataIndex: "personGroupEnd",
    key: "personGroupEnd",
    ellipsis: true,
    render: (_, record) => {
      return (record?.personGroupEnd?._instanceName);
    },
  },
  {
    title: <FormattedMessage id="endDate" />,
    dataIndex: "dateEnd",
    key: "dateEnd",
    ellipsis: true,
    render: (_, record) => {
      return (record?.dateEnd);
    },
  },
  {
    title: <FormattedMessage id="cba.detail.comments" />,
    dataIndex: "commentEnd",
    key: "commentEnd",
    ellipsis: true,
    render: (_, record) => {
      return (record?.commentEnd);
    },
  },
];

@inject("rootStore")
@observer
class OrderRegisterSheet extends React.Component<Props & RootStoreProp & RouteComponentProps & WrappedComponentProps, State> {

  state: State = {
    orderRegisterSheet: null,
    isLoading: false,
    isLoadingSheet: false,
    selectedStatuses: {},
    selectedComment: {},
    isModalVisible: false,
    selectedTask: null,
    orderRegisterSheetId: "",
    checkedBalance: false,
    isLoadingDocument: false,
    isSaving: false,
    isRevised: false,
    isNotAttach: false,
    documentInfo: {
      finalFile: false,
      isSignatureRequired: true,
      ucoSignRegistrationId: [],
      signature: null,
    },
  };

  @observable statusesDc = collection<DicAssessmentStatus>(
    "kzm_DicTaskStatusOrderRegisterSheet",
    {
      view: "_local",
    },
  );
  @observable
  attachmentsArray: LearningBudgetAttachment[] = [];

  @action
  setAttachmentsArray = (value: any): void => {
    this.attachmentsArray = value;
  };


  columnsAttachments = [
    {
      title: <FormattedMessage id={"file"} />,
      dataIndex: "attachments",
      render: renderFileLink,
    },
    {
      title: <FormattedMessage id={"dismissal.workAroundSheet.user"} />,
      dataIndex: "file",
      render: (_: string, record: any) => {
        const userFullName = (record.personGroup && record.personGroup.fullName) && record.personGroup.fullName;
        return <span>{userFullName || this.props.rootStore!.userInfo.fullName}</span>;
      },
    },
    {
      title: <FormattedMessage id={"comment"} />,
      dataIndex: "fileComment",
      key: "comment",
    },
  ];

  handleStatusChange = (taskId: string, value: string) => {
    this.setState((prevState) => ({
      selectedStatuses: {
        ...prevState.selectedStatuses,
        [taskId]: value,
      },
    }));
  };

  loadEntity = async () => {
    const result = await restServices.orderRegisterSheetService.getOrderRegisterSheetByOrderId({ orderId: this.props.orderId || "" });

    this.setState({
      orderRegisterSheetId: result,
    });
    return restServices.orderRegisterSheetService.getOrderRegisterSheetForEmployeeById({
      employeeId: this.props.rootStore!.userInfo.personGroupId!,
      orderRegisterSheetId: result,
    });
  };

  getRegistrations = async (id: string) => {
    if (this.props.entityId !== "new" && id) {
      try {
        const res = await restServices.getNewAbbService.getSignFile(id, "BUSINESS_TRIP");

        this.setState((prevState: any) => ({
          documentInfo: {
            ...prevState.documentInfo,
            isSignatureRequired: res.isSignatureRequired,
            ucoSignRegistrationId: res.ucoSignRegistrationId,
          },
        }));

        if (!res.isSignatureRequired) {
          return;
        }

        this.setState({
          isRevised: !!res.ucoSignRegistrationId,
          isLoadingDocument: true,
        });
      } catch (error) {
        console.error("Error fetching sign file:", error);
      }
    }
  };


  async componentDidMount() {
    this.statusesDc.load();
    this.setState({ isLoadingSheet: true });
    try {
      const res = await this.loadEntity();

      this.setState({ orderRegisterSheet: res });
      this.attachmentsArray = [];
      this.attachmentsArray = res.attachments;

      this.getRegistrations(res.id);
    } catch (e) {

    } finally {
      this.setState({ isLoadingSheet: false });
    }
  }

  async componentDidUpdate(prevProps: any) {
    if (prevProps.entityId !== this.props.entityId) {
      try {
        const res = await this.loadEntity();

        this.setState({ orderRegisterSheet: res });
        this.attachmentsArray = [];
        this.attachmentsArray = res.attachments;
      } catch (e) {

      } finally {
        this.setState({ isLoadingSheet: false });
      }
    }
  }

  showModal = (taskId: string) => {
    // const personGroupId = this.props.rootStore!.userInfo.personGroupId;
    // const isAttach = this.state.orderRegisterSheet.attachments.filter(item => item.personGroup.id === personGroupId)?.length;
    // const isManagerTask = this.state.orderRegisterSheet?.orderRegisterSheetTaskList?.length === 1 && this.state.orderRegisterSheet?.orderRegisterSheetTaskList[0]?.taskOrder === 1;
    //
    // if (!isAttach && isManagerTask) return this.setState({
    //   isNotAttach: !isAttach,
    //   isModalVisible: true,
    //   selectedTask: taskId,
    // });

    this.setState({ isModalVisible: true, selectedTask: taskId });
  };


  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  // print = () => {
  //   const reportCodeList = "TERMINATION_CHECK_LIST";
  //
  //   const loadingNotificationKey = "loadingNotification";
  //   Notification.info({
  //     message: this.props.intl.formatMessage({ id: "cubaReact.dataTable.loading" }),
  //     key: loadingNotificationKey,
  //     duration: 0,
  //   });
  //
  //   const data = {
  //     parameters: [{
  //       name: "id",
  //       value: this.state.orderRegisterSheetId,
  //     }],
  //   };
  //
  //   runReport(reportCodeList, data, this.props.intl)
  //     .finally(() => {
  //       Notification.info({
  //         message: this.props.intl.formatMessage({ id: "cubaReact.dataTable.loading" }),
  //         key: loadingNotificationKey,
  //         duration: 1,
  //       });
  //     });
  // };
  handleCommentChange = (taskId: string, event: ChangeEvent<HTMLTextAreaElement>) => {
    const comment = event.target.value;

    if (taskId) {
      this.setState((prevState) => ({
        selectedComment: {
          ...prevState.selectedComment,
          [taskId]: comment,
        },
      }));
    }
  };

  render() {

    const isDisabled = true;
    if (this.state.isLoadingSheet) return <Spin spinning size={"large"} />;

    if (!this.state.orderRegisterSheet || !this.state.orderRegisterSheet.id) {
      return null;
    }

    if (!this.state.orderRegisterSheet || !this.state.orderRegisterSheet.id) return <>Не найдено</>;

    const uniqueOrganizationIds = Array.from(
      new Set(this.state.orderRegisterSheet.orderRegisterSheetTaskList.map(item => item.organization?.id)),
    );

    const tasksByOrganization = uniqueOrganizationIds?.reduce((acc, orgId) => {
      acc[orgId] = this.state.orderRegisterSheet?.orderRegisterSheetTaskList?.filter(item => item.organization?.id === orgId);
      return acc;
    }, {} as any);


    const updateSheet = async () => {
      this.setState({ isLoading: true });
      const obj = this.state.orderRegisterSheet;
      const key = "fileComment";
      obj!.attachments = this.attachmentsArray.map(item => {
        return {
          fileId: (item!.file!.id),
          fileComment: item[key] || "",
        };
      });
      try {
        await restServices.orderRegisterSheetService.saveOrderRegisterSheetAttachments({
          orderRegisterSheetId: obj?.id,
          fileIdList: obj?.attachments,
        });
      } finally {
        this.setState({ isLoading: false });
      }
    };

    const actions = [
      <Button
        key={"update"}
        style={{ backgroundColor: "green" }}
        onClick={updateSheet}
        disabled={this.state.isLoading}
      >
        <FormattedMessage id={"save"} />
      </Button>,
      // <Button
      //   key={"print"}
      //   buttonType={ButtonType.PRIMARY}
      //   onClick={this.print}>
      //   <FormattedMessage id={"print"} />
      // </Button>,
    ];

    const changeStatus = async () => {
      const taskId = this.state.selectedTask || "";
      const personGroupId = this.props.rootStore!.userInfo.personGroupId;

      this.setState({ isLoading: true });
      try {

        await restServices.orderRegisterSheetService.closeOrderRegisterSheetTask({
          orderRegisterSheetId: this.state.orderRegisterSheet!.id,
          orderRegisterSheetTaskId: taskId,
          taskStatus: get(this.state.selectedStatuses, taskId, ""),
          employeeId: personGroupId,
          comment: get(this.state.selectedComment, taskId, ""),
        });

        const res = await this.loadEntity();

        this.setState({ orderRegisterSheet: res });

        await this.getRegistrations(this.state.orderRegisterSheet!.id);
      } catch (e) {
      } finally {
        this.setState({ isLoading: false });
      }
    };

    const handleOk = async () => {
      if (this.state.isNotAttach) return this.setState({ isNotAttach: false });
      await changeStatus();
      this.handleCancel();
    };

    return (
      <CollapsibleCard
        title={<FormattedMessage id={"registerOrderRequest.sheet"} />}
        cardProps={{
          className: "narrow-layout card-actions-container",
        }}
        panelKey="unique-panel-key"
      >
        <Spin spinning={this.state.isLoading}>
          <Section size={"large"}>
            {/*<div style={{ display: "flex", gap: "16px" }}>*/}
            {/*  <Form.Item*/}
            {/*    style={{ width: "100%" }}*/}
            {/*    label={<FormattedMessage id={"absence.employee"} />}*/}
            {/*  >*/}
            {/*    <Input value={this.state.orderRegisterSheet?.employee?.["_instanceName"]} disabled={isDisabled} />*/}
            {/*  </Form.Item>*/}
            {/*  <Form.Item*/}
            {/*    style={{ width: "100%" }}*/}
            {/*    label={<FormattedMessage id={"individualPlan.edit.organization"} />}*/}
            {/*  >*/}
            {/*    <Input*/}
            {/*      value={this.state.orderRegisterSheet?.employeeAssignment?.organizationGroup["_instanceName"]}*/}
            {/*      disabled={isDisabled} />*/}
            {/*  </Form.Item>*/}
            {/*  <Form.Item*/}
            {/*    style={{ width: "100%" }}*/}
            {/*    label={<FormattedMessage id={"positionGroup"} />}*/}
            {/*  >*/}
            {/*    <Input*/}
            {/*      value={this.state.orderRegisterSheet?.employeeAssignment?.positionGroup["_instanceName"]}*/}
            {/*      disabled={isDisabled} />*/}
            {/*  </Form.Item>*/}
            {/*</div>*/}

            <div className="flex lg:flex-row flex-col gap-2 lg:gap-4">
              <Form.Item
                className="w-full lg:w-1/2"
                label={<FormattedMessage id="dismissal.workAroundSheet.dateApplication" />}
              >
                <DatePicker
                  className="w-full"
                  value={moment(this.state.orderRegisterSheet?.startDateBusinessTripRequest)}
                  disabled={isDisabled}
                />
              </Form.Item>

              <Form.Item
                className="w-full lg:w-1/2"
                label={<FormattedMessage id="dismissal.workAroundSheet.dateDismissal" />}
              >
                <DatePicker
                  className="w-full"
                  value={moment(this.state.orderRegisterSheet?.endDateBusinessTripRequest)}
                  disabled={isDisabled}
                />
              </Form.Item>
            </div>

          </Section>
          {uniqueOrganizationIds.map(orgId => {
            return (
              <Section key={orgId} size={"large"}>
                <div className={"flex lg:flex-row flex-col lg:items-center gap-2 lg:gap-4 mb-4"}>
                  <div className={"sheet-label"}><FormattedMessage id={"dismissal.workAroundSheet.function"} /></div>

                  <Input
                    className={"w-full"}
                    value={this.state.orderRegisterSheet?.orderRegisterSheetTaskList?.find(item => item.organization?.id === orgId)?.organization?._instanceName}
                    disabled={isDisabled}
                  />
                </div>

                {
                  tasksByOrganization[orgId].map((item: OrderRegisterSheetTask) => (
                    <div key={item.id} className={"flex flex-col gap-4"}>

                      {
                        (item?.responsibleList && item?.responsibleList.length > 0) && (
                          <div className={"flex lg:flex-row flex-col lg:items-center gap-2 lg:gap-4"}>
                            <div className={"sheet-label"}><FormattedMessage id={"dismissal.workAroundSheet.employers"} />
                            </div>
                            <TextArea
                              className={"w-full"}
                              disabled={isDisabled}
                              value={
                                item?.responsibleList
                                  ?.map(item => `${item["_instanceName"]}${item?.mobilePhone ? ", " + item?.mobilePhone : ""}`)
                                  .join("; ") + ";"
                              }
                            />
                          </div>
                        )
                      }


                      <div className={"flex lg:flex-row flex-col lg:items-center gap-2 lg:gap-4 mb-4"}>
                        <div className={"sheet-label"}><FormattedMessage id={"description"} /></div>

                        <TextArea
                          className={"w-full"}
                          value={item._instanceName}
                          disabled={isDisabled}
                        />

                        <Select
                          value={this.state.selectedStatuses[item.id] || item.taskStatus.id}
                          placeholder="Select task status"
                          style={{ minWidth: 160, width: 160 }}
                          disabled={!!item?.dateEnd}
                          onChange={(value: string) => this.handleStatusChange(item.id, value)}
                        >
                          {this.statusesDc.items.map((status) => (
                            <Select.Option key={status.id} value={status.id}>
                              {status.langValue1}
                            </Select.Option>
                          ))}
                        </Select>
                        <Button
                          onClick={() => this.showModal(item.id)}
                          className="close-button"
                          disabled={!!item?.dateEnd}
                        >
                          <FormattedMessage id={"dismissal.workAroundSheet.close"} />
                        </Button>
                      </div>

                      <TableAdaptive
                        dataSource={[item]}
                        pagination={false}
                        key="tasks-table"
                        bordered
                        rowKey="id"
                        isNeedMobile
                        scroll={{ x: 900 }}
                        columns={getTaskColumns(this.props.intl, undefined, undefined)}
                      />
                    </div>
                  ))
                }
              </Section>
            );
          })}
          {(this.state.documentInfo.ucoSignRegistrationId) &&
            <CollapsibleCard title={<FormattedMessage id={"bussinessTrip.cost.documents"} />}>
              <DocumentSignatureComponentNew
                isRedirect={false}
                isNotiffqr={false}
                isSaving={false}
                entityId={this.props.entityId}
                documentInfo={this.state.documentInfo}
                setDocumentInfo={this.setDocumentInfo}
                status={false}
                isFull={true}
              />
            </CollapsibleCard>
          }

          <Section size={"large"} sectionName={<FormattedMessage id={"dismissal.workAroundSheet.attachments"} />}>
            <Card actions={actions} bordered={false}>
              <AttachmentsComponent
                isForecast={false}
                isNeedDelete={false}
                isNeedComment={true}
                columns={this.columnsAttachments}
                items={(this.attachmentsArray as any) || []}
                setAttachment={this.setAttachmentsArray}
                keyComment={"fileComment"}
              />
            </Card>
          </Section>

          <Modal
            title={<FormattedMessage id={this.state.isNotAttach ? "attention" : "placeholder.comment"} />}
            visible={this.state.isModalVisible}
            onOk={handleOk}
            onCancel={this.handleCancel}
            okText={this.state.isNotAttach ? <FormattedMessage id={"confirm.onOk"} /> :
              <FormattedMessage id={"cbaSend"} />}
            cancelText={this.state.isNotAttach ? <FormattedMessage id={"confirm.onCancel"} /> :
              <FormattedMessage id={"form.cancel"} />}
          >
            {this.state.isNotAttach
              ? <h1><FormattedMessage id={"attachment-attention"} /></h1>
              :
              <Input.TextArea
                rows={4}
                value={get(this.state.selectedComment, this.state.selectedTask || "", "")}
                onChange={(event) => {
                  if (this.state.selectedTask) {
                    this.handleCommentChange(this.state.selectedTask, event);
                  }
                }}
                placeholder={""}
              />
            }
          </Modal>
        </Spin>
      </CollapsibleCard>

    );
  }

  setDocumentInfo = (arg: ChangeDocumentInfo) => {
    const { finalFile, signature } = arg;

    this.setState((prevState: any) => {
      const updatedDocumentInfo = {
        ...prevState.documentInfo,
        ...(finalFile && { finalFile }),
        ...(signature && { signature }),
      };
      return { documentInfo: updatedDocumentInfo };
    });
  };

}

export default injectIntl(withRouter(OrderRegisterSheet));
